import { Component, OnInit } from '@angular/core';
import { BillingService } from '../../../services/billing.service';
import { ReportFiltersComponent } from '../reports/report-filters/report-filters.component';
import { ListTableComponent } from '../../../shared/components/list-table/list-table.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { UserService } from '../../../services/user.service';
import { LookupService } from '../../../services/lookup.service';

@Component({
  selector: 'ppl-resubmission-report',
  standalone: true,
  imports: [ReportFiltersComponent, ListTableComponent, NgApexchartsModule],
  templateUrl: './resubmission-report.component.html',
  styleUrl: './resubmission-report.component.css',
})
export class ResubmissionReportComponent implements OnInit {
  programName: any;
  resubmissionReportData: any;
  chartOptions: any;
  selectedClaimType = 'All';
  mcoName : any;
  mcoList: any[] = [];
  metricType = 'RESUB_REASON';
  resubDate = 'All';
  resubReason = 'All';
  filterFields = [
    { field: 'metricType', show: true, default: 'RESUB_REASON' },
    { field: 'resubDate', show: true, default: 'All' },
    { field: 'resubReason', show: true, default: 'All' },
    { field: 'mcoName', show: true, default: '' },
    { field: 'selectedClaimType', show: true, default: 'All' },
  ];
  baseCols = [
    {
      field: 'resubDate',
      header: 'Resub Date',
      jsonpath: 'resubDate',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'resubReason',
      header: 'Resub Reason',
      jsonpath: 'resubReason',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'mcoName',
      header: 'MCO',
      jsonpath: 'mcoName',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'count',
      header: 'Count',
      jsonpath: 'count',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
  ];
  cols: any;

  constructor(private billingService: BillingService, private userService: UserService, private lookupService: LookupService) {}

  ngOnInit(): void {
    const selectedProgram = this.userService.getSelectedProgram();
    this.programName = selectedProgram?.program_code ?? '';
    this.lookupService.getOrgData(this.programName).subscribe((data: any) => {
      if (data.status === 200) {
        this.mcoList = data.responsedata.filter((item: any) => item.orgTypeLookup === 'MCO');
        this.mcoName = this.mcoList[0]?.orgName;
        this.filterFields = this.filterFields?.map(f =>
          f.field === 'mcoName' ? { ...f, default: this.mcoList[0]?.orgName } : f
        ) ?? [];
        this.getResubReportData();
      }
    });
    const cols = [...this.baseCols];
    if (this.metricType === 'MCO') {
      this.cols = cols.filter((col) => col.field !== 'resubReason');
    } else if (this.metricType === 'RESUB_REASON') {
      this.cols = cols.filter((col) => col.field !== 'mcoName');
    } else {
      this.cols = cols;
    }
  }

  getResubReportData() {
    const option = {
      reportName: 'fetchResubmissionReport',
      mcoName: this.mcoName,
      programCode: this.programName,
      splitBy: this.metricType,
      resubReason: this.resubReason,
      claimType: this.selectedClaimType,
      resubDate: this.resubDate,
    };

    this.billingService.getReports(option).subscribe((data: any) => {
      this.resubmissionReportData = data.responsedata || [];
    });
  }

  filterChanged(change: any) {
    this.selectedClaimType = change.formValues.selectedClaimType;
    this.mcoName = change.formValues.mcoName;
    this.metricType = change.formValues.metricType;
    this.resubDate = change.formValues.resubDate;
    this.resubReason = change.formValues.resubReason;

    if (change.field === 'metricType') {
      const cols = [...this.baseCols];
      if (change.formValues.metricType === 'MCO') {
        this.cols = cols.filter((col) => col.field !== 'resubReason');
      } else if (change.formValues.metricType === 'RESUB_REASON') {
        this.cols = cols.filter((col) => col.field !== 'mcoName');
      } else {
        this.cols = cols;
      }
    }

    this.getResubReportData();
  }
}
